import { render, staticRenderFns } from "./JsonDataDialog.vue?vue&type=template&id=155aa7ef"
import script from "./JsonDataDialog.vue?vue&type=script&lang=js"
export * from "./JsonDataDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports